export const mainDetailsData = ({ claimDetails: { data: {
  amendsClaim,
  amendsClaimDateFiled,
  basisForClaim,
  claimNumber,
  dateFiled,
  debtor,
  id,
  isContingent,
  isDisputed,
  isObjected,
  isObjectionResolved,
  isUnliquidated,
  objectionBasis,
  relatedClaimsFiled,
  relatedDocs,
  relatedSchedule,
  representsSchedule,
  schedule,
  status,
  typeOfClaim,
} } }) => ({
  amendsClaim,
  amendsClaimDateFiled,
  basisForClaim,
  claimNumber,
  dateFiled,
  debtor,
  id,
  isContingent,
  isDisputed,
  isObjected,
  isObjectionResolved,
  isUnliquidated,
  objectionBasis,
  relatedClaimsFiled,
  relatedDocs,
  relatedSchedule,
  representsSchedule,
  schedule,
  status,
  typeOfClaim,
});

export const moneyInfoData = ({ claimDetails: { data: {
  administrativeAmount,
  amountOfClaim,
  calculatedTotal,
  originalAdministrativeAmount,
  originalPriorityAmount,
  originalSecuredAmount,
  originalUnsecuredAmount,
  priorityAmount,
  securedAmount,
  unsecuredAmount,
} } }) => ({
  administrativeAmount,
  amountOfClaim,
  calculatedTotal,
  originalAdministrativeAmount,
  originalPriorityAmount,
  originalSecuredAmount,
  originalUnsecuredAmount,
  priorityAmount,
  securedAmount,
  unsecuredAmount,
});

export const scheduleInfoData = ({ claimDetails: { data: { schedule = {} } } }) => schedule;

export const creditors = ({ claimDetails: { data: { creditors: dataSet = [] } } }) => dataSet;



// WEBPACK FOOTER //
// ./src/store/selectors/claimDetails.js